import { Dialog } from "@mui/material";
import styled from "styled-components";

export const CustomDialog = styled(Dialog)<{ scale: number }>`
	z-index: 99999;
	.MuiPaper-root {
		transform: scale(${(props) => props?.scale});
		border-radius: 25px;
		padding-bottom: 0.15rem;
		width: 370px;
		height: 346px;
		min-width: 370px;
		min-height: 346px;
	}
`;
